/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestingRouteImport } from './routes/testing'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout-success'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AmbassadorProgramRouteImport } from './routes/ambassador-program'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RoundsIndexRouteImport } from './routes/rounds/index'
import { Route as CoursesIndexRouteImport } from './routes/courses.index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as RoundsRoundIdRouteImport } from './routes/rounds/$roundId'
import { Route as BlogWhatIsStrokesGainedRouteImport } from './routes/blog/what-is-strokes-gained'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthRedirectRouteImport } from './routes/auth/redirect'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthCreatePasswordRouteImport } from './routes/auth/create-password'
import { Route as AccountTeamsRouteImport } from './routes/account/teams'
import { Route as AccountSubscriptionPlanRouteImport } from './routes/account/subscription-plan'
import { Route as AccountSettingsRouteImport } from './routes/account/settings'
import { Route as miscTermsAndConditionsRouteImport } from './routes/(misc)/terms-and-conditions'
import { Route as miscPrivacyPolicyRouteImport } from './routes/(misc)/privacy-policy'
import { Route as RoundsRoundIdIndexRouteImport } from './routes/rounds/$roundId.index'
import { Route as AccountTeamsIndexRouteImport } from './routes/account/teams.index'
import { Route as AccountAdminIndexRouteImport } from './routes/account/admin.index'
import { Route as AccountTeamsTeamIdRouteImport } from './routes/account/teams.$teamId'
import { Route as AccountAdminSplatRouteImport } from './routes/account/admin.$'
import { Route as RoundsRoundIdHoleHoleNumberRouteImport } from './routes/rounds/$roundId.hole.$holeNumber'

const TestingRoute = TestingRouteImport.update({
  id: '/testing',
  path: '/testing',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: '/checkout-success',
  path: '/checkout-success',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const AmbassadorProgramRoute = AmbassadorProgramRouteImport.update({
  id: '/ambassador-program',
  path: '/ambassador-program',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RoundsIndexRoute = RoundsIndexRouteImport.update({
  id: '/rounds/',
  path: '/rounds/',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesIndexRoute = CoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BlogRoute,
} as any)
const RoundsRoundIdRoute = RoundsRoundIdRouteImport.update({
  id: '/rounds/$roundId',
  path: '/rounds/$roundId',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogWhatIsStrokesGainedRoute = BlogWhatIsStrokesGainedRouteImport.update({
  id: '/what-is-strokes-gained',
  path: '/what-is-strokes-gained',
  getParentRoute: () => BlogRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRedirectRoute = AuthRedirectRouteImport.update({
  id: '/auth/redirect',
  path: '/auth/redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCreatePasswordRoute = AuthCreatePasswordRouteImport.update({
  id: '/auth/create-password',
  path: '/auth/create-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountTeamsRoute = AccountTeamsRouteImport.update({
  id: '/account/teams',
  path: '/account/teams',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountSubscriptionPlanRoute = AccountSubscriptionPlanRouteImport.update({
  id: '/account/subscription-plan',
  path: '/account/subscription-plan',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountSettingsRoute = AccountSettingsRouteImport.update({
  id: '/account/settings',
  path: '/account/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const miscTermsAndConditionsRoute = miscTermsAndConditionsRouteImport.update({
  id: '/(misc)/terms-and-conditions',
  path: '/terms-and-conditions',
  getParentRoute: () => rootRouteImport,
} as any)
const miscPrivacyPolicyRoute = miscPrivacyPolicyRouteImport.update({
  id: '/(misc)/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const RoundsRoundIdIndexRoute = RoundsRoundIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RoundsRoundIdRoute,
} as any)
const AccountTeamsIndexRoute = AccountTeamsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountTeamsRoute,
} as any)
const AccountAdminIndexRoute = AccountAdminIndexRouteImport.update({
  id: '/account/admin/',
  path: '/account/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountTeamsTeamIdRoute = AccountTeamsTeamIdRouteImport.update({
  id: '/$teamId',
  path: '/$teamId',
  getParentRoute: () => AccountTeamsRoute,
} as any)
const AccountAdminSplatRoute = AccountAdminSplatRouteImport.update({
  id: '/account/admin/$',
  path: '/account/admin/$',
  getParentRoute: () => rootRouteImport,
} as any)
const RoundsRoundIdHoleHoleNumberRoute =
  RoundsRoundIdHoleHoleNumberRouteImport.update({
    id: '/hole/$holeNumber',
    path: '/hole/$holeNumber',
    getParentRoute: () => RoundsRoundIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ambassador-program': typeof AmbassadorProgramRoute
  '/blog': typeof BlogRouteWithChildren
  '/checkout-success': typeof CheckoutSuccessRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/pricing': typeof PricingRoute
  '/testing': typeof TestingRoute
  '/privacy-policy': typeof miscPrivacyPolicyRoute
  '/terms-and-conditions': typeof miscTermsAndConditionsRoute
  '/account/settings': typeof AccountSettingsRoute
  '/account/subscription-plan': typeof AccountSubscriptionPlanRoute
  '/account/teams': typeof AccountTeamsRouteWithChildren
  '/auth/create-password': typeof AuthCreatePasswordRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/redirect': typeof AuthRedirectRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/blog/what-is-strokes-gained': typeof BlogWhatIsStrokesGainedRoute
  '/rounds/$roundId': typeof RoundsRoundIdRouteWithChildren
  '/blog/': typeof BlogIndexRoute
  '/courses/': typeof CoursesIndexRoute
  '/rounds/': typeof RoundsIndexRoute
  '/account/admin/$': typeof AccountAdminSplatRoute
  '/account/teams/$teamId': typeof AccountTeamsTeamIdRoute
  '/account/admin/': typeof AccountAdminIndexRoute
  '/account/teams/': typeof AccountTeamsIndexRoute
  '/rounds/$roundId/': typeof RoundsRoundIdIndexRoute
  '/rounds/$roundId/hole/$holeNumber': typeof RoundsRoundIdHoleHoleNumberRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ambassador-program': typeof AmbassadorProgramRoute
  '/checkout-success': typeof CheckoutSuccessRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/pricing': typeof PricingRoute
  '/testing': typeof TestingRoute
  '/privacy-policy': typeof miscPrivacyPolicyRoute
  '/terms-and-conditions': typeof miscTermsAndConditionsRoute
  '/account/settings': typeof AccountSettingsRoute
  '/account/subscription-plan': typeof AccountSubscriptionPlanRoute
  '/auth/create-password': typeof AuthCreatePasswordRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/redirect': typeof AuthRedirectRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/blog/what-is-strokes-gained': typeof BlogWhatIsStrokesGainedRoute
  '/blog': typeof BlogIndexRoute
  '/courses': typeof CoursesIndexRoute
  '/rounds': typeof RoundsIndexRoute
  '/account/admin/$': typeof AccountAdminSplatRoute
  '/account/teams/$teamId': typeof AccountTeamsTeamIdRoute
  '/account/admin': typeof AccountAdminIndexRoute
  '/account/teams': typeof AccountTeamsIndexRoute
  '/rounds/$roundId': typeof RoundsRoundIdIndexRoute
  '/rounds/$roundId/hole/$holeNumber': typeof RoundsRoundIdHoleHoleNumberRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ambassador-program': typeof AmbassadorProgramRoute
  '/blog': typeof BlogRouteWithChildren
  '/checkout-success': typeof CheckoutSuccessRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/pricing': typeof PricingRoute
  '/testing': typeof TestingRoute
  '/(misc)/privacy-policy': typeof miscPrivacyPolicyRoute
  '/(misc)/terms-and-conditions': typeof miscTermsAndConditionsRoute
  '/account/settings': typeof AccountSettingsRoute
  '/account/subscription-plan': typeof AccountSubscriptionPlanRoute
  '/account/teams': typeof AccountTeamsRouteWithChildren
  '/auth/create-password': typeof AuthCreatePasswordRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/redirect': typeof AuthRedirectRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/blog/what-is-strokes-gained': typeof BlogWhatIsStrokesGainedRoute
  '/rounds/$roundId': typeof RoundsRoundIdRouteWithChildren
  '/blog/': typeof BlogIndexRoute
  '/courses/': typeof CoursesIndexRoute
  '/rounds/': typeof RoundsIndexRoute
  '/account/admin/$': typeof AccountAdminSplatRoute
  '/account/teams/$teamId': typeof AccountTeamsTeamIdRoute
  '/account/admin/': typeof AccountAdminIndexRoute
  '/account/teams/': typeof AccountTeamsIndexRoute
  '/rounds/$roundId/': typeof RoundsRoundIdIndexRoute
  '/rounds/$roundId/hole/$holeNumber': typeof RoundsRoundIdHoleHoleNumberRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ambassador-program'
    | '/blog'
    | '/checkout-success'
    | '/dashboard'
    | '/demo'
    | '/pricing'
    | '/testing'
    | '/privacy-policy'
    | '/terms-and-conditions'
    | '/account/settings'
    | '/account/subscription-plan'
    | '/account/teams'
    | '/auth/create-password'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/redirect'
    | '/auth/reset-password'
    | '/auth/sign-up'
    | '/blog/what-is-strokes-gained'
    | '/rounds/$roundId'
    | '/blog/'
    | '/courses/'
    | '/rounds/'
    | '/account/admin/$'
    | '/account/teams/$teamId'
    | '/account/admin/'
    | '/account/teams/'
    | '/rounds/$roundId/'
    | '/rounds/$roundId/hole/$holeNumber'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ambassador-program'
    | '/checkout-success'
    | '/dashboard'
    | '/demo'
    | '/pricing'
    | '/testing'
    | '/privacy-policy'
    | '/terms-and-conditions'
    | '/account/settings'
    | '/account/subscription-plan'
    | '/auth/create-password'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/redirect'
    | '/auth/reset-password'
    | '/auth/sign-up'
    | '/blog/what-is-strokes-gained'
    | '/blog'
    | '/courses'
    | '/rounds'
    | '/account/admin/$'
    | '/account/teams/$teamId'
    | '/account/admin'
    | '/account/teams'
    | '/rounds/$roundId'
    | '/rounds/$roundId/hole/$holeNumber'
  id:
    | '__root__'
    | '/'
    | '/ambassador-program'
    | '/blog'
    | '/checkout-success'
    | '/dashboard'
    | '/demo'
    | '/pricing'
    | '/testing'
    | '/(misc)/privacy-policy'
    | '/(misc)/terms-and-conditions'
    | '/account/settings'
    | '/account/subscription-plan'
    | '/account/teams'
    | '/auth/create-password'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/redirect'
    | '/auth/reset-password'
    | '/auth/sign-up'
    | '/blog/what-is-strokes-gained'
    | '/rounds/$roundId'
    | '/blog/'
    | '/courses/'
    | '/rounds/'
    | '/account/admin/$'
    | '/account/teams/$teamId'
    | '/account/admin/'
    | '/account/teams/'
    | '/rounds/$roundId/'
    | '/rounds/$roundId/hole/$holeNumber'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AmbassadorProgramRoute: typeof AmbassadorProgramRoute
  BlogRoute: typeof BlogRouteWithChildren
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute
  DashboardRoute: typeof DashboardRoute
  DemoRoute: typeof DemoRoute
  PricingRoute: typeof PricingRoute
  TestingRoute: typeof TestingRoute
  miscPrivacyPolicyRoute: typeof miscPrivacyPolicyRoute
  miscTermsAndConditionsRoute: typeof miscTermsAndConditionsRoute
  AccountSettingsRoute: typeof AccountSettingsRoute
  AccountSubscriptionPlanRoute: typeof AccountSubscriptionPlanRoute
  AccountTeamsRoute: typeof AccountTeamsRouteWithChildren
  AuthCreatePasswordRoute: typeof AuthCreatePasswordRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRedirectRoute: typeof AuthRedirectRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  RoundsRoundIdRoute: typeof RoundsRoundIdRouteWithChildren
  CoursesIndexRoute: typeof CoursesIndexRoute
  RoundsIndexRoute: typeof RoundsIndexRoute
  AccountAdminSplatRoute: typeof AccountAdminSplatRoute
  AccountAdminIndexRoute: typeof AccountAdminIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/testing': {
      id: '/testing'
      path: '/testing'
      fullPath: '/testing'
      preLoaderRoute: typeof TestingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout-success': {
      id: '/checkout-success'
      path: '/checkout-success'
      fullPath: '/checkout-success'
      preLoaderRoute: typeof CheckoutSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ambassador-program': {
      id: '/ambassador-program'
      path: '/ambassador-program'
      fullPath: '/ambassador-program'
      preLoaderRoute: typeof AmbassadorProgramRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rounds/': {
      id: '/rounds/'
      path: '/rounds'
      fullPath: '/rounds/'
      preLoaderRoute: typeof RoundsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/': {
      id: '/courses/'
      path: '/courses'
      fullPath: '/courses/'
      preLoaderRoute: typeof CoursesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof BlogRoute
    }
    '/rounds/$roundId': {
      id: '/rounds/$roundId'
      path: '/rounds/$roundId'
      fullPath: '/rounds/$roundId'
      preLoaderRoute: typeof RoundsRoundIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/what-is-strokes-gained': {
      id: '/blog/what-is-strokes-gained'
      path: '/what-is-strokes-gained'
      fullPath: '/blog/what-is-strokes-gained'
      preLoaderRoute: typeof BlogWhatIsStrokesGainedRouteImport
      parentRoute: typeof BlogRoute
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/redirect': {
      id: '/auth/redirect'
      path: '/auth/redirect'
      fullPath: '/auth/redirect'
      preLoaderRoute: typeof AuthRedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/create-password': {
      id: '/auth/create-password'
      path: '/auth/create-password'
      fullPath: '/auth/create-password'
      preLoaderRoute: typeof AuthCreatePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/teams': {
      id: '/account/teams'
      path: '/account/teams'
      fullPath: '/account/teams'
      preLoaderRoute: typeof AccountTeamsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/subscription-plan': {
      id: '/account/subscription-plan'
      path: '/account/subscription-plan'
      fullPath: '/account/subscription-plan'
      preLoaderRoute: typeof AccountSubscriptionPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/settings': {
      id: '/account/settings'
      path: '/account/settings'
      fullPath: '/account/settings'
      preLoaderRoute: typeof AccountSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(misc)/terms-and-conditions': {
      id: '/(misc)/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof miscTermsAndConditionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(misc)/privacy-policy': {
      id: '/(misc)/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof miscPrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rounds/$roundId/': {
      id: '/rounds/$roundId/'
      path: '/'
      fullPath: '/rounds/$roundId/'
      preLoaderRoute: typeof RoundsRoundIdIndexRouteImport
      parentRoute: typeof RoundsRoundIdRoute
    }
    '/account/teams/': {
      id: '/account/teams/'
      path: '/'
      fullPath: '/account/teams/'
      preLoaderRoute: typeof AccountTeamsIndexRouteImport
      parentRoute: typeof AccountTeamsRoute
    }
    '/account/admin/': {
      id: '/account/admin/'
      path: '/account/admin'
      fullPath: '/account/admin/'
      preLoaderRoute: typeof AccountAdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/teams/$teamId': {
      id: '/account/teams/$teamId'
      path: '/$teamId'
      fullPath: '/account/teams/$teamId'
      preLoaderRoute: typeof AccountTeamsTeamIdRouteImport
      parentRoute: typeof AccountTeamsRoute
    }
    '/account/admin/$': {
      id: '/account/admin/$'
      path: '/account/admin/$'
      fullPath: '/account/admin/$'
      preLoaderRoute: typeof AccountAdminSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rounds/$roundId/hole/$holeNumber': {
      id: '/rounds/$roundId/hole/$holeNumber'
      path: '/hole/$holeNumber'
      fullPath: '/rounds/$roundId/hole/$holeNumber'
      preLoaderRoute: typeof RoundsRoundIdHoleHoleNumberRouteImport
      parentRoute: typeof RoundsRoundIdRoute
    }
  }
}

interface BlogRouteChildren {
  BlogWhatIsStrokesGainedRoute: typeof BlogWhatIsStrokesGainedRoute
  BlogIndexRoute: typeof BlogIndexRoute
}

const BlogRouteChildren: BlogRouteChildren = {
  BlogWhatIsStrokesGainedRoute: BlogWhatIsStrokesGainedRoute,
  BlogIndexRoute: BlogIndexRoute,
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

interface AccountTeamsRouteChildren {
  AccountTeamsTeamIdRoute: typeof AccountTeamsTeamIdRoute
  AccountTeamsIndexRoute: typeof AccountTeamsIndexRoute
}

const AccountTeamsRouteChildren: AccountTeamsRouteChildren = {
  AccountTeamsTeamIdRoute: AccountTeamsTeamIdRoute,
  AccountTeamsIndexRoute: AccountTeamsIndexRoute,
}

const AccountTeamsRouteWithChildren = AccountTeamsRoute._addFileChildren(
  AccountTeamsRouteChildren,
)

interface RoundsRoundIdRouteChildren {
  RoundsRoundIdIndexRoute: typeof RoundsRoundIdIndexRoute
  RoundsRoundIdHoleHoleNumberRoute: typeof RoundsRoundIdHoleHoleNumberRoute
}

const RoundsRoundIdRouteChildren: RoundsRoundIdRouteChildren = {
  RoundsRoundIdIndexRoute: RoundsRoundIdIndexRoute,
  RoundsRoundIdHoleHoleNumberRoute: RoundsRoundIdHoleHoleNumberRoute,
}

const RoundsRoundIdRouteWithChildren = RoundsRoundIdRoute._addFileChildren(
  RoundsRoundIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AmbassadorProgramRoute: AmbassadorProgramRoute,
  BlogRoute: BlogRouteWithChildren,
  CheckoutSuccessRoute: CheckoutSuccessRoute,
  DashboardRoute: DashboardRoute,
  DemoRoute: DemoRoute,
  PricingRoute: PricingRoute,
  TestingRoute: TestingRoute,
  miscPrivacyPolicyRoute: miscPrivacyPolicyRoute,
  miscTermsAndConditionsRoute: miscTermsAndConditionsRoute,
  AccountSettingsRoute: AccountSettingsRoute,
  AccountSubscriptionPlanRoute: AccountSubscriptionPlanRoute,
  AccountTeamsRoute: AccountTeamsRouteWithChildren,
  AuthCreatePasswordRoute: AuthCreatePasswordRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRedirectRoute: AuthRedirectRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  RoundsRoundIdRoute: RoundsRoundIdRouteWithChildren,
  CoursesIndexRoute: CoursesIndexRoute,
  RoundsIndexRoute: RoundsIndexRoute,
  AccountAdminSplatRoute: AccountAdminSplatRoute,
  AccountAdminIndexRoute: AccountAdminIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
